const countryByCallingCode = {
  "1": "USA",
  "34": "España",
  "45": "Dinamarca",
  "51": "Perú",
  "52": "México",
  "54": "Argentina",
  "57": "Colombia",
  "593": "Ecuador",
  "598": "Uruguay",
  "506": "Costa Rica",
};

const areaCodesByProvince = {
  "Buenos Aires": [
    "11", "22", "23", "24", "220", "221", "223", "230", "236", "237", "249", "291",
    "292", "293", "336", "348", "2982", "2983", "3327", "3329", "3388", "3407",
    "3487", "3489",
  ],
  "Catamarca": ["383", "3832", "3835", "3837", "3838"],
  "Chaco": ["362", "364", "372", "373"],
  "Chubut": ["280", "297", "2903", "2945"],
  "Córdoba": [
    "351", "352", "353", "354", "355", "356", "357", "358", "2336", "3385",
    "3387", "3463", "3467", "3468", "3472",
  ],
  "Corrientes": ["377", "378", "379", "3756"],
  "Entre Ríos": ["343", "344", "345"],
  "Formosa": ["370", "371"],
  "Jujuy": ["388"],
  "La Pampa": ["295", "2302", "2331", "2333", "2334", "2335", "2338"],
  "La Rioja": ["380", "382"],
  "Mendoza": ["260", "261", "262", "263"],
  "Misiones": ["374", "375", "376"],
  "Neuquén": ["299", "2942", "2948", "2972"],
  "Río Negro": ["294", "298", "2920", "2931", "2934", "2940", "2946"],
  "Salta": ["387", "3868"],
  "San Juan": ["264"],
  "San Luis": ["265", "266"],
  "Santa Cruz": ["296", "2902"],
  "Santa Fe": [
    "340", "341", "342", "346", "349", "3382", "3471", "3476", "3482", "3483",
  ],
  "Santiago del Estero": ["384", "385"],
  "Tierra del Fuego": ["2901", "2964"],
  "Tucumán": ["381", "386", "389"],
};

const provinceByAreaCode = Object.fromEntries(
  Object.entries(areaCodesByProvince).flatMap(([province, areaCodes]) =>
    areaCodes.map((areaCode) => [areaCode, province])
  )
);

const AMBA_SUBSCRIBER_NUMBER_LENGTH = 8;

const hasLocationValue = (value) =>
  typeof value === "string"
    ? value.trim() !== "" && value.trim() !== "-"
    : value !== undefined && value !== null;

const getPhoneLocation = (phone) => {
  const phoneText = String(phone || "").trim();
  const phoneDigits = phoneText.replace(/\D/g, "");
  if (!phoneDigits) return {};

  let nationalNumber = phoneDigits;
  let country = "Argentina";
  const hasInternationalPrefix = phoneText.startsWith("+") || phoneText.startsWith("00");

  if (nationalNumber.startsWith("00")) nationalNumber = nationalNumber.slice(2);

  const callingCode =
    hasInternationalPrefix || nationalNumber.startsWith("54")
      ? Object.keys(countryByCallingCode)
        .sort((firstCode, secondCode) => secondCode.length - firstCode.length)
        .find((code) => nationalNumber.startsWith(code))
      : undefined;

  if (callingCode) {
    country = countryByCallingCode[callingCode];
    nationalNumber = nationalNumber.slice(callingCode.length);
  }

  if (country !== "Argentina") return { country };

  nationalNumber = nationalNumber.replace(/^0/, "").replace(/^9/, "");
  if (nationalNumber.length === AMBA_SUBSCRIBER_NUMBER_LENGTH) {
    return { country, region: provinceByAreaCode["11"] };
  }

  const areaCode = Object.keys(provinceByAreaCode)
    .sort((firstCode, secondCode) => secondCode.length - firstCode.length)
    .find((code) => nationalNumber.startsWith(code));

  return { country, region: areaCode ? provinceByAreaCode[areaCode] : undefined };
};

export const getStudentLocation = (student) => {
  const phoneLocation = getPhoneLocation(student.phone);
  const guessedCountry = !hasLocationValue(student.country) && phoneLocation.country;
  const guessedRegion = !hasLocationValue(student.region) && phoneLocation.region;

  return {
    country: guessedCountry || student.country,
    region: guessedRegion || student.region,
    isGuessed: Boolean(guessedCountry || guessedRegion),
  };
};
